import React, {useState, useEffect}from "react";
import Header from "../include/header";
import Footer from "../include/footer";
import LeftPanel from "../include/leftpanel";
import axios from "axios";
import Global from "../../APIConfig";
import { json, useNavigate,useParams } from "react-router-dom";
import AuthUser from "../../AuthUser";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { Modal,Button, Alert } from 'react-bootstrap';


function Createshipmentb2b() {
    let navigate = useNavigate();
    const [booking_Type, setBooking_Type] = useState('Domestic');
    const [manualAWB, setManualAWB] = useState('');
    const [todaydate, setTodayDate] = useState(getTodayDateString());
    const [currentTime, setCurrentTime] = useState(new Date());
    const [product_Type, setProduct_Type] = useState('Parcel');
    const [billtype, setBilltype] = useState('Cash');
    const [billcustomerlist, setBillcustomerlist] = useState([]);
    const [customerlist, setCustomerlist] = useState([]);
    const [selectedcustomer, setSelectedcustomer] = useState([]);
    const [billpayid, setBillpayid] = useState('0');
    const [senderautofilltype, setSenderautofilltype] = useState('phone');
    const [senderautofilldata, setSenderautofilldata] = useState('');
    const [senderautofilllist, setSenderautofilllist] = useState('');
    const [sendercompanyname, setSendercompanyname] = useState('');
    const [sendercustomername, setSendercustomername] = useState('');
    const [sendermobilenumber, setSendermobilenumber] = useState('');
    const [senderemail, setSenderemail] = useState('');
    const [senderAddress, setSenderAddress] = useState('');
    const [senderPostalcode, setSenderPostalcode] = useState('');
    const [sendercountryname, setSendercountryname] = useState('');
    const [sendercountryid, setSendercountryid] = useState('');
    const [sendercityName, setSendercityName] = useState('');
    const [sendercityId, setSendercityId] = useState('');
    const [defaultCurrency, setDefaultCurrency] = useState('$');
    const [receiverautofilltype, setReceiverautofilltype] = useState('phone');
    const [receiverautofilldata, setReceiverautofilldata] = useState('');
    const [receiverautofilllist, setReceiverautofilllist] = useState('');
    const [receivercompanyname, setReceivercompanyname] = useState('');
    const [receivercustomername, setReceivercustomername] = useState('');
    const [receivermobilenumber, setReceivermobilenumber] = useState('');
    const [receiveremail, setReceiveremail] = useState('');
    const [receiverAddress, setReceiverAddress] = useState('');
    const [receiverPostalcode, setReceiverPostalcode] = useState('');
    const [receivercountryname, setReceivercountryname] = useState('');
    const [receivercountryid, setReceivercountryid] = useState('');
    const [receivercityName, setReceivercityName] = useState('');
    const [receivercityId, setReceivercityId] = useState('');
    const {headers1,headers2,logout}=AuthUser();
    const [paymenttype, setPaymenttype] = useState('Prepaid');
    const [codprice,setCodprice] = useState('0');
    const [insurance, setInsurance] = useState('No');
    const formattedTime = currentTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    const [showSelectBox, setShowSelectBox] = useState(false);
    const [countrylist, setCountrylist] = useState([]);
    const [defaultCountry, setDefaultCountry] = useState('');
    const [senderdefaultCountryid, setSenderDefaultCountryid] = useState('');
    const [receiverdefaultCountryid, setReceiverdefaultCountryid] = useState('');
    const [showReceiverSelectBox, setShowReceiverSelectBox] = useState(false);
    const [showCustomerSelectBox, setShowCustomerSelectBox] = useState(false);
    const [servicelist, setServicelist] = useState([]);
    const [selectedservicelist, setSelectedservicelist] = useState('');
    const [setloader, setSetloader] = useState(false);
    const [userdata, setUserdata] = useState('');
    const [citylist, setCitylist] = useState([]);
    const [pincodeSenderCity, setPincodeSenderCity] = useState([]);
    const [pincodeReceiverCity, setPincodeReceiverCity] = useState([]);
    const [shipmentstatus, setShipmentstatus] = useState('B');
    const [sender_save_yes, setSender_save_yes] = useState('no');
    const [receiver_save_yes, setReceiver_save_yes] = useState('no');
    const [showModal, setShowModal] = useState(false); // Modal visibility state
    const [packages, setPackages] = useState([{ BoxNumber: "", Height: "", Width: "", Length: "", Weight: ""}]);
    const [orderbags, setOrderbags] = useState([{orderid:"",no_boxes:""}]);
    const [invoices, setInvoices] = useState([{EWayBillNumber:"",InvoiceNumber:"",Amount:""}]);
    const [description, setDescription] = useState('');
    const [isChecked, setIsChecked] = useState(true);
    const [selectedFile, setSelectedFile] = useState(null);
    const [lR_Type, setLR_Type] = useState('Automatic')
    const [lRNumber, setLRNumber] = useState('')
    const [secondaryDocumnet, setSecondaryDocumnet] = useState('')
    const [selectedSecondryFile, setSelectedSecondryFile] = useState(null);


    useEffect(()=>{
        GetCountrylist();
        GetdefaultCountry();
        GetdefaultCountryid();
        const items = JSON.parse(localStorage.getItem('user'));
        if (items) {
         setUserdata(items);
        }
        const timerId = setInterval(() => {
            setCurrentTime(new Date());
        }, 10000);
        return () => clearInterval(timerId);
        
    },[]);

    const filterBy = (option, state)=> {
        if (state.selected.length) {
          return true;
        }
        return option.label.toLowerCase().indexOf(state.text.toLowerCase()) > -1;
      }

    const totalBags = orderbags.reduce((sum, item) => {
        return sum + Number(item.no_boxes || 0);
      }, 0);

    const addPackage = () => {
        if (packages.length < totalBags) {
        setPackages([...packages, { 
            BoxNumber: "", Height: "", Width: "", Length: "", Weight: "",
        }]);
    } else {
        toast.error(`You can only add up to ${totalBags} packages based on the box count.`);
      }
    };
    
    const handlechangepackage = (e, packageIndex) => {
        const { name, value } = e.target;
    
        setPackages((prev) => 
            prev.map((pkg, i) => 
                i === packageIndex ? { ...pkg, [name]: value } : pkg
            )
        );
    };

    const handleDelete=(i)=>{
        const deleteVal = [...packages]
        deleteVal.splice(i,1)
        setPackages(deleteVal);
    }

    const getTotalValues = () => {
        return packages.reduce(
            (total, pkg) => ({
                Height: total.Height + (parseFloat(pkg.Height) || 0),
                Width: total.Width + (parseFloat(pkg.Width) || 0),
                Length: total.Length + (parseFloat(pkg.Length) || 0),
                Weight: total.Weight + (parseFloat(pkg.Weight) || 0),
            }),
            { Height: 0, Width: 0, Length: 0, Weight: 0 } // Initial values
        );
    };

    const totalValues = getTotalValues();
    
    const GetCountrylist=()=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'Countrylist',
            data: {
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data.value;
                setCountrylist(data);
            }
          })
          .catch(function (error) {
            // console.log(error);
            // setLoading(false);
          });
    }
    
    const GetdefaultCountryid=()=>
    {
        axios({
            method: 'post',
            url: Global.baseUrl+'SiteconfigData',
            data: {
                fliedname: "default_country"
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data.value;
                setSenderDefaultCountryid(data);
                setReceiverdefaultCountryid(data);
            }
          })
          .catch(function (error) {
            // console.log(error);
            // setLoading(false);
          });
          axios({
            method: 'post',
            url: Global.baseUrl+'SiteconfigData',
            data: {
                fliedname: "default_currency"
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data.value;
                setDefaultCurrency(data);
            }
          })
          .catch(function (error) {
            // console.log(error);
            // setLoading(false);
          });
    }

    const GetdefaultCountry=()=>
    {
        axios({
            method: 'post',
            url: Global.baseUrl+'defaultcountryname',
            data: {
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data.value;
                setDefaultCountry(data);
                setSendercountryname(data);
                setReceivercountryname(data);
                GetCityList(data);
            }
          })
          .catch(function (error) {
            // console.log(error);
            // setLoading(false);
          });
    }

    const GetCityList=(val)=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'Citylist',
            data: {
                name: val
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data.value;
                setCitylist(data);
            }
          })
          .catch(function (error) {
            // console.log(error);
            // setLoading(false);
          });
    }

    const handelbilltypecustomer=(e)=>{
        setBilltype(e);
        GetBilltocustomerlist(e);
    }

     const handelSecondaryDocumnet=(e)=>{
        setSecondaryDocumnet(e);
    }

    const handelshipmentstatustype=(e)=>{
        setShipmentstatus(e)
    }

    const handelbillbyid=(e)=>{
        const id = e[0].value;
        const name = e[0].label;
        setSelectedcustomer(name)
        setBillpayid(id);
    }
    

    const GetBilltocustomerlist=(val)=>{
        if(val !='Cash')
        {
            axios({
                method: 'post',
                url: Global.baseUrl+'Customerlist',
                headers:headers1,
                data: {
                    cust_type: val
                }
            })
            .then(function (response) {
                if(response.data.status == 200)
                {
                    setBillcustomerlist(response.data.value);
                }
                else
                {
                    setBillcustomerlist([]);
                }
            })
            .catch(function (error) {
                if(error.response.status==401){
                    toast.error(error.response.statusText);
                    logout();
                    navigate('/');
                    window.location.reload();
                }
                // console.log(error);
            });
        }
    }

    // Function to get today's date in the format "YYYY-MM-DD"
    function getTodayDateString() {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }

      const handlesenderdata=(id)=>{
        setSenderautofilldata(id);
        setShowSelectBox(false);
        axios({
            method: 'post',
            url: Global.baseUrl+'Customerdatabyuniqueid',
            headers:headers1,
            data: {
                uniqueid: id,
                filltype: senderautofilltype,
            }
        })
        .then(function (response) {
            if(response.data.status == 200)
            {
                const data = response.data.value;
                setSendercompanyname(data.company);
                setSendercustomername(data.name);
                setSendermobilenumber(data.phone);
                setSenderemail(data.email);
                setSenderAddress(data.address);
                setSenderPostalcode(data.pincode);
                setSendercountryname(data.countryname);
                setSendercountryid(data.country);
                setSendercityName(data.cityname);
                setSendercityId(data.city);
                setPincodeSenderCity([{value: data.city, label:data.cityname}]);

            }
            else
            {
                setSendercustomername('');
                setSendermobilenumber('');
                setSenderemail('');
                setSenderAddress('');
                setSenderPostalcode('');
                setSendercountryname('');
                setSendercountryid('');
                setSendercityName('');
                setSendercityId('');
                setPincodeSenderCity([]);
                
            }
        })
        .catch(function (error) {
            if(error.response.status==401){
                toast.error(error.response.statusText);
                logout();
                navigate('/');
                window.location.reload();
            }
            // console.log(error);
        });
      }

      const handleReceiverdata=(id)=>{
        setReceiverautofilldata(id);
        setShowReceiverSelectBox(false);
        axios({
            method: 'post',
            url: Global.baseUrl+'Customerdatabyuniqueid',
            headers:headers1,
            data: {
                uniqueid: id,
                filltype: receiverautofilltype,
                
            }
        })
        .then(function (response) {
            if(response.data.status == 200)
            {
                const data = response.data.value;
                setReceivercompanyname(data.company);
                setReceivercustomername(data.name);
                setReceivermobilenumber(data.phone);
                setReceiveremail(data.email);
                setReceiverAddress(data.address);
                setReceiverPostalcode(data.pincode);
                setReceivercountryname(data.countryname);
                setReceivercountryid(data.country);
                setReceivercityName(data.cityname);
                setReceivercityId(data.city);
                setPincodeReceiverCity([{value: data.city, label:data.cityname}]);
                

            }
            else
            {
                setReceivercustomername('');
                setReceivermobilenumber('');
                setReceiveremail('');
                setReceiverAddress('');
                setReceiverPostalcode('');
                setReceivercountryname('');
                setReceivercountryid('');
                setReceivercityName('');
                setReceivercityId('');
                setPincodeReceiverCity([]);
                
            }
        })
        .catch(function (error) {
            if(error.response.status==401){
                toast.error(error.response.statusText);
                logout();
                navigate('/');
                window.location.reload();
            }
            // console.log(error);
        });
      }

      const handlesendersearchdata=(val)=>{
        setSenderautofilldata(val);
        if(val.length >2 && senderautofilltype !='')
        {
            axios({
                method: 'post',
                url: Global.baseUrl+'Customerdatasearch',
                headers:headers1,
                data: {
                    senderautofilltype: senderautofilltype,
                    senderautofilldata: val
                }
            })
            .then(function (response) {
                if(response.data.status == 200)
                {
                    setSenderautofilllist(response.data.value);
                    setShowSelectBox(true);

                }
                else
                {
                    setSenderautofilllist([]);
                    setShowSelectBox(false);
                }
            })
            .catch(function (error) {
                if(error.response.status==401){
                    toast.error(error.response.statusText);
                    logout();
                    navigate('/');
                    window.location.reload();
                }
                // console.log(error);
            });
        }
        else
        {
            setShowSelectBox(false);
        }
      }

      const handlereceiversearchdata=(val)=>{
        setReceiverautofilldata(val);
        if(val.length >2 && receiverautofilltype !='')
        {
            axios({
                method: 'post',
                url: Global.baseUrl+'Customerdatasearch',
                headers:headers1,
                data: {
                    senderautofilltype: receiverautofilltype,
                    senderautofilldata: val
                }
            })
            .then(function (response) {
                if(response.data.status == 200)
                {
                    setReceiverautofilllist(response.data.value);
                    setShowReceiverSelectBox(true);

                }
                else
                {
                    setReceiverautofilllist([]);
                    setShowReceiverSelectBox(false);
                }
            })
            .catch(function (error) {
                if(error.response.status==401){
                    toast.error(error.response.statusText);
                    logout();
                    navigate('/');
                    window.location.reload();
                }
                // console.log(error);
            });
        }
        else
        {
            setShowReceiverSelectBox(false);
        }
      }

      const handelsendercountry=(e)=>{
        setSendercountryname(e.target.options[e.target.selectedIndex].text);
        GetCityList(e.target.options[e.target.selectedIndex].text);
        setSendercityName('');
        setSendercityId('');
        setSendercountryid(e.target.value);
        setServicelist([]);
        setPincodeSenderCity([]);
      }

      const handelreceivercountry=(e)=>{
        setReceivercountryname(e.target.options[e.target.selectedIndex].text);
        GetCityList(e.target.options[e.target.selectedIndex].text);
        setReceivercityName('');
        setReceivercityId('');
        setReceivercountryid(e.target.value);
        setServicelist([]);
        setPincodeReceiverCity([]);
      }

      const handelsenderautoselectcity = (selectedOptions) => {
        setPincodeSenderCity(selectedOptions);
        if (selectedOptions.length > 0) {
          const selectedOption = selectedOptions[0];
          setSendercityName(selectedOption.label);
          setSendercityId(selectedOption.value);
        } else {
            setSendercityName('');
          setSendercityId('');
        }
        setServicelist([]);
      };

      const handelReceiverautoselectcity=(e)=>{
        setPincodeReceiverCity(e)
        if (e.length > 0) {
            const id = e[0].value;
            const name = e[0].label;
            setReceivercityName(name);
            setReceivercityId(id);
        }
        else
        {
            setReceivercityName('');
            setReceivercityId('');
        }
        setServicelist([]);
      }


      const handleSenderSaveAddress = (e) => {
        setSender_save_yes(e.target.checked ? 'yes' : 'no');
      };
    
      const handleReceiverSaveAddress = (e) => {
        setReceiver_save_yes(e.target.checked ? 'yes' : 'no');
      };

      const totalnoofBox = packages.reduce((sum, item) => {
        return sum + Number(item.BoxNumber || 0);
      }, 0);

      const handelservice=()=>{
        if(lR_Type =="Manual" && lRNumber =="")
        {
            toast.warn('Please enter manual AWB No.');
            return;
        }
        if(sendercustomername =="")
        {
            toast.warn('Please enter sender customer name');
            return;
        }
        if(sendermobilenumber =="")
        {
            toast.warn('Please enter sender customer mobile number');
            return;
        }
        if(senderAddress =="")
        {
            toast.warn('Please enter sender customer address');
            return;
        }
        if(sendercountryname =="")
        {
            toast.warn('Please select sender country');
            return;
        }
        if(sendercityName =="")
        {
            toast.warn('Please select sender city');
            return;
        }
        if(receivercustomername =="")
        {
            toast.warn('Please enter receiver customer name');
            return;
        }
        if(receivermobilenumber =="")
        {
            toast.warn('Please enter receiver customer mobile number');
            return;
        }
        if(receiverAddress =="")
        {
            toast.warn('Please enter receiver customer address');
            return;
        }
        if(receivercountryname =="")
        {
            toast.warn('Please Select receiver country');
            return;
        }
        if(receivercityName =="")
        {
            toast.warn('Please select receiver city');
            return;
        }
        if(description =="")
        {
            toast.warn('Please enter description');
            return;
        }
        for (let i = 0; i < orderbags.length; i++) 
        {
            const refid = orderbags[i];

            if(!refid.orderid) //|| isNaN(refid.orderid)
            {
                toast.warn('Please enter your reference id / order id');
                return;
            }
            if(!refid.no_boxes  || isNaN(refid.no_boxes))
            {
                toast.warn('Please enter No. of boxes');
                return;
            }
        }
        for (let i = 0; i < invoices.length; i++) 
            {
                const invoiceno = invoices[i];
    
                if(!invoiceno.InvoiceNumber) // || isNaN(invoiceno.InvoiceNumber)
                {
                    toast.warn('Please enter invoice number');
                    return;
                }
                if(!invoiceno.Amount  || isNaN(invoiceno.Amount))
                {
                    toast.warn('Please enter amount');
                    return;
                }
            }
        for (let i = 0; i < packages.length; i++) 
        {
            const pkg = packages[i];
    
            if (!pkg.BoxNumber || isNaN(pkg.BoxNumber)) {
                toast.warn(`Package ${i + 1}: Please enter a valid box Number.`);
                return;
            }
            if (!pkg.Height || isNaN(pkg.Height)) {
                toast.warn(`Package ${i + 1}: Please enter a valid height.`);
                return;
            }
            if (!pkg.Width || isNaN(pkg.Width)) {
                toast.warn(`Package ${i + 1}: Please enter a valid width.`);
                return;
            }
            if (!pkg.Length || isNaN(pkg.Length)) {
                toast.warn(`Package ${i + 1}: Please enter a valid length.`);
                return;
            }
            if (!pkg.Weight || isNaN(pkg.Weight)) {
                toast.warn(`Package ${i + 1}: Please enter a valid weight.`);
                return;
            }
        }
        // if (!selectedFile) {
        //     toast.error('No file selected. Please select file');
        //     return;
        // } 
        if (totalnoofBox < totalBags) 
        {
            toast.error(`Please provide details on all ${totalBags} Boxes`);
            return;
        }
        axios({
            method: 'post',
            url: Global.baseUrl+'showservice',
            headers:headers1,
            data: {
                sendercountryid: sendercountryid,
                sendercityId : sendercityId,
                senderpincode : senderPostalcode,
                receivercountryid: receivercountryid,
                receivercityId: receivercityId,
                receiverpincode: receiverPostalcode,
                products: packages,
                height: totalValues.Height,
                width: totalValues.Width,
                length: totalValues.Length,
                weight: totalValues.Weight,
                booking_Type: booking_Type,
                product_Type: product_Type,
                cust_id:billpayid,
                insurance:insurance,
                paymenttype:paymenttype,
                codprice:codprice,
                type:userdata.usertype,
                agent_id:0,
                type:'B2B'

            }
        })
        .then(function (response) {
            if(response.data.status == 200)
            {
                setServicelist(response.data.value);
                setShowModal(true); // Open the modal using state
            }
            else
            {
                toast.warn(response.data.message);
                setServicelist([]);
            }
        })
        .catch(function (error) {
            if(error.response.status==401){
                toast.error(error.response.statusText);
                logout();
                navigate('/');
                window.location.reload();
            }
            // console.log(error);
        });
        }

      const handleClose = () => {
        setServicelist([]);
        setShowModal(false); // Close modal handler
      }

      const handelsenderpostalcode=(zipcode)=>{
        setServicelist([]);
        axios({
            method: 'post',
            url: Global.baseUrl+'countrydatabypincode',
            headers:headers1,
            data: {
                Postalcode: zipcode,
            }
        })
        .then(function (response) {
            if(response.data.status == 200)
            {
                setSenderDefaultCountryid('');
                setSendercountryid(response.data.value.countryid);
                setSendercityName(response.data.value.city);
                setSendercityId(response.data.value.id);
                setPincodeSenderCity([{value: response.data.value.id, label: response.data.value.city}]);
            }
            else
            {
                setSendercountryid('');
                setSendercityName('');
                setSendercityId('');
                setPincodeSenderCity([]);
            }
        })
        .catch(function (error) {
            if(error.response.status==401){
                toast.error(error.response.statusText);
                logout();
                navigate('/');
                window.location.reload();
            }
            // console.log(error);
        });
        }

        const handelreceiverpostalcode=(zipcode)=>{
            setServicelist([]);
        axios({
        method: 'post',
        url: Global.baseUrl+'countrydatabypincode',
        headers:headers1,
        data: {
            Postalcode: zipcode,
        }
        })
        .then(function (response) {
        if(response.data.status == 200)
        {
            setReceiverdefaultCountryid('');
            setReceivercountryid(response.data.value.countryid);
            setReceivercityName(response.data.value.city);
            setReceivercityId(response.data.value.id);
            setPincodeReceiverCity([{value: response.data.value.id, label: response.data.value.city}]);
            
        }
        else
        {
            setReceivercountryid('');
            setReceivercityName('');
            setReceivercityId('');
            setPincodeReceiverCity([]);
        }
        })
        .catch(function (error) {
        if(error.response.status==401){
            toast.error(error.response.statusText);
            logout();
            navigate('/');
            window.location.reload();
        }
        // console.log(error);
        });
        }
      const handelactiveservice=(index)=>{
             const newList= servicelist[index];
             setSelectedservicelist(newList);
      }
      const createshipment=()=>{
        if(lR_Type =="Manual" && lRNumber =="")
        {
            toast.warn('Please enter manual AWB No.');
            return;
        }
        if(sendercustomername =="")
        {
            toast.warn('Please Enter Sender Customer Name');
            return;
        }
        if(sendermobilenumber =="")
        {
            toast.warn('Please Enter Sender Customer Mobile Number');
            return;
        }
        if(senderAddress =="")
        {
            toast.warn('Please Enter Sender Customer Address');
            return;
        }
        if(sendercountryname =="")
        {
            toast.warn('Please Select Sender Country');
            return;
        }
        if(sendercityName =="")
        {
            toast.warn('Please Select Sender City');
            return;
        }
        if(receivercustomername =="")
        {
            toast.warn('Please Enter Receiver Customer Name');
            return;
        }
        if(receivermobilenumber =="")
        {
            toast.warn('Please Enter Receiver Customer Mobile Number');
            return;
        }
        if(receiverAddress =="")
        {
            toast.warn('Please Enter Receiver Customer Address');
            return;
        }
        if(receivercountryname =="")
        {
            toast.warn('Please Select Receiver Country');
            return;
        }
        if(receivercityName =="")
        {
            toast.warn('Please Select Receiver city');
            return;
        }
        // if(secondaryDocumnet !="")
        // {
        //     toast.warn('Please Select Secondary Document');
        //     return;
        // }
        // if (!selectedSecondryFile) {
        //     toast.error('Please Secondary option');
        //     return;
        // } 
        if(selectedservicelist =="")
        {
            toast.warn("Please Select Service");
            return;
        }
        setSetloader(true);
        axios({
            method: 'post',
            url: Global.baseUrl+'CreateShipmentB2B',
            headers:headers2,
            data: {
                booking_Type: booking_Type,
                manualAWB:manualAWB,
                todaydate:todaydate,
                currentTime:formattedTime,
                product_Type: product_Type,
                billtype:billtype,
                sendercompanyname:sendercompanyname,
                sendercustomername:sendercustomername,
                sendermobilenumber:sendermobilenumber,
                senderemail:senderemail,
                senderAddress:senderAddress,
                senderPostalcode:senderPostalcode,
                sendercityId : sendercityId,
                sendercountryid:sendercountryid,
                receivercompanyname:receivercompanyname,
                receivercustomername:receivercustomername,
                receivermobilenumber:receivermobilenumber,
                receiveremail:receiveremail,
                receiverAddress:receiverAddress,
                receiverPostalcode:receiverPostalcode,
                receivercityId: receivercityId,
                receivercountryid:receivercountryid,
                productsdetails: packages,
                packageslength:totalBags,
                paymenttype:paymenttype,
                codprice:codprice,
                insurance:insurance,
                servicedetails:selectedservicelist,
                cust_id:billpayid,
                type:userdata.usertype,
                agent_id:0,
                user_id:userdata.id,
                hub_id:0,
                shipmentstatus:shipmentstatus,
                sender_save_yes:sender_save_yes,
                receiver_save_yes:receiver_save_yes,
                orderDetails: orderbags,
                invoiceDetails: invoices,
                document: selectedFile,
                description:description,
                lR_Type:lR_Type,
                lRNumber:lRNumber,
                secondaryDocumnet:secondaryDocumnet,
                selectedSecondryFile:selectedSecondryFile,
            }
        })
        .then(function (response) {
            if(response.data.status == 200)
            {
                toast.success(response.data.message);
                setSetloader(false);
                setTimeout(() => {
                    navigate('/Shipmentlistb2b/All');
                    }, 1000);
            }
            else
            {
                toast.warn(response.data.message);
                setSetloader(false);
            }
        })
        .catch(function (error) {
            if(error.response.status==401){
                toast.error(error.response.statusText);
                logout();
                navigate('/');
                window.location.reload();
            }
            // console.log(error);
        });
      }

      const orderaddInput = () => {
        setOrderbags([...orderbags,{orderid:"",no_boxes:""}]); 

        };
  const handleorderDelete=(i)=>{
    const deleteVal = [...orderbags]
    deleteVal.splice(i,1)
    setOrderbags(deleteVal);
}

const handleorderchange=(e,i)=>{
    setServicelist([]);
    const {name,value} = e.target
    const onchangeVal = [...orderbags]
    onchangeVal[i][name]=value
    setOrderbags(onchangeVal);
}

const InvoicesaddInput = () => {
    const lastInvoice = invoices[invoices.length - 1];

    const amount = Number(lastInvoice.Amount || 0);
    const eway = lastInvoice.EWayBillNumber.trim();

    if (amount > 50000 && !eway && !isChecked) {
        toast.error("Please enter E-Way Bill Number or check the box for exemption.");
        return; // prevent adding new row
    }
    setInvoices([...invoices,{EWayBillNumber:"",InvoiceNumber:"",Amount:""}]); 
    };

    const handleInvoicesDelete=(i)=>{
    const deleteVal = [...invoices]
    deleteVal.splice(i,1)
    setInvoices(deleteVal);
    }

    const handleInvoiceschange=(e,i)=>{
    setServicelist([]);
    const {name,value} = e.target
    const onchangeVal = [...invoices]
    onchangeVal[i][name]=value
    setInvoices(onchangeVal);
    }

    const handleChange = (e) => {
        setIsChecked(e.target.checked);
      };

      const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            setSelectedFile(selectedFile);
        }
      };

      const handleFileChangeSecondary = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            setSelectedSecondryFile(selectedFile);
        }
      };
      

    return (
        <>
            <LeftPanel />
            <main className='home-section'>
                <Header />
                <ToastContainer/>
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                    <div className="d-block mb-4 mb-md-0">
                        <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
                            <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
                                <li className="breadcrumb-item">
                                    <a href="/Admin-Dash">
                                        <i className="bx bx-home text-primary-400 fs-6"></i>
                                    </a>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">All Shipments</li>
                            </ol>
                        </nav>
                        <div className="d-flex justify-content-between">
                            <div className="">
                                <button className="btn btn_nav btn-sm" type="button" onClick={()=>navigate(-1)}>
                                    <i className="bx bx-arrow-back "></i>
                                </button>
                            </div>
                            <div className="ps-2 ">
                                <h2 className="h4">Create Shipment</h2>
                            </div>
                        </div>
                    </div>

                    <div className="btn-toolbar mb-2 mb-md-0">
                    </div>
                </div>

                <section className="container">
                    <div className="row">
                        <div className="col-12 col-md-8">
                            <section className="mb-4">
                                <h5>LR Details</h5>
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-12 col-md-6 mb-3">
                                                <label className="form-label">Shipment Booking Type:</label>
                                                <div>
                                                    <div className="form-check form-check-inline">
                                                        <input className="form-check-input" type="radio" id="Domestic" checked={booking_Type == 'Domestic'} onChange={()=>setBooking_Type('Domestic')}/>
                                                        <label className="form-check-label" htmlhtmlFor="Domestic">Domestic</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input className="form-check-input" type="radio" id="International" checked={booking_Type == 'International'} onChange={()=>setBooking_Type('International')}/>
                                                        <label className="form-check-label" htmlhtmlFor="International">International</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6 mb-3">
                                                <label className="form-label">Shipment Product Type:</label>
                                                <div>
                                                    <div className="form-check form-check-inline">
                                                        <input className="form-check-input" type="radio" id="Parcel" checked={product_Type == 'Parcel'} onChange={()=>setProduct_Type('Parcel')}/>
                                                        <label className="form-check-label" htmlhtmlFor="Parcel">Parcel</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input className="form-check-input" type="radio" id="Document" checked={product_Type == 'Document'} onChange={()=>setProduct_Type('Document')}/>
                                                        <label className="form-check-label" htmlhtmlFor="Document">Document</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-12 mb-3">
                                                <label className="form-label">LR creation:</label>
                                                <div>
                                                    <div className="form-check form-check-inline">
                                                        <input className="form-check-input" type="radio" id="Manual" checked={lR_Type == 'Manual'} onChange={()=>setLR_Type('Manual')}/>
                                                        <label className="form-check-label" for="Manual">Manual</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input className="form-check-input" type="radio" id="Automatic" checked={lR_Type == 'Automatic'} onChange={()=>setLR_Type('Automatic')}/>
                                                        <label className="form-check-label" for="Automatic">Automatic</label>
                                                    </div>
                                                </div>
                                            </div>
                                            {lR_Type ==='Manual' ?
                                            <div className="form-check form-check-inline">
                                                <input className="form-control" type="text" placeholder="Enter LR number" value={lRNumber} onChange={(e)=>setLRNumber(e.target.value)}/>
                                            </div>
                                            :
                                            <label><i className="bx bx-help-circle"></i> LR number will be autofilled once you manifest the shipment</label>
                                            }
                                            <div className="col-12 col-md-4 mt-3">
                                                <label className="form-label">Billing Type:</label>
                                                <select className="form-select" onChange={(e)=>handelbilltypecustomer(e.target.value)}>
                                                    <option value='Cash'>Cash</option>
                                                    <option value='Contract'>Contract</option>
                                                    <option value='Credit'>Credit</option>
                                                    <option value='Wallet'>Wallet</option>
                                                </select>
                                            </div>
                                            {billtype !='Cash' &&
                                            <div className="col-12 col-md-4 mt-3">
                                                <label className="form-label">Select Customer:</label>
                                                <Typeahead
                                                    filterBy={filterBy}
                                                    id="toggle-example1"
                                                    options={billcustomerlist}
                                                    placeholder="Choose a customer..."
                                                    onChange={handelbillbyid}
                                                />
                                            </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </section>

                            <section className="mb-4">
                                <div className="row">
                                    <div className="col-12 col-md">
                                        <h5>Add Senders Details</h5>
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="d-flex justify-content-between mb-4">
                                                    <small className="text-muted">Where is the order being sent from?</small>
                                                    <div className="text-end">
                                                        <small><a data-bs-toggle="collapse" data-bs-target="#autofill" className="text-primary">Use Auto Fill<i className="bx bx-chevron-down"></i></a></small>
                                                    </div>
                                                </div>

                                                <div className="row ">
                                                    <div className="col-12 col-md-12 mb-3 collapse show" id="autofill">
                                                        <label className="form-label">Auto Fill details using:</label>
                                                        <div className="input-group select_account">
                                                            <select className="form-select" style={{"width": "20px !important"}} onChange={(e)=>setSenderautofilltype(e.target.value)}>
                                                                {/* <option value=''>--Please Select--</option> */}
                                                                <option value='phone'>Mobile</option>
                                                                <option value='uniqueid'>Account Number</option>
                                                                <option value='address'>Address UID</option>
                                                            </select>
                                                            <input type="text" className="form-control" placeholder="Enter details to fetch data" value={senderautofilldata} onChange={(e)=>handlesendersearchdata(e.target.value)} />
                                                            
                                                        </div>
                                                        {showSelectBox &&
                                                            <select className="form-select customtypehead" size="5" onChange={(e)=>handlesenderdata(e.target.value)}>
                                                                {senderautofilllist.map((al,i)=>{
                                                                return(
                                                                <option value={al.value} className="searchtypehead">{al.label} {al.value}</option>
                                                                    )
                                                                })}
                                                            </select>
                                                            }
                                                    </div>
                                                    <div className="col-12 col-md-12 mb-3">
                                                        <label className="form-label">Company Name:</label>
                                                        <input type="text" className="form-control" value={sendercompanyname} placeholder="Enter Company Name" onChange={(e)=>setSendercompanyname(e.target.value)} />
                                                    </div>
                                                    <div className="col-12 col-md-12 mb-3">
                                                        <label className="form-label">Full Customer Name <span className="text-danger">*</span> :</label>
                                                        <input type="text" className="form-control" value={sendercustomername} placeholder="Enter Customer Name" onChange={(e)=>setSendercustomername(e.target.value)} />
                                                    </div>
                                                    <div className="col-12 col-md-6 mb-3">
                                                        <label className="form-label">Mobile Number <span className="text-danger">*</span>:</label>
                                                        <input type="number" className="form-control" value={sendermobilenumber} placeholder="Enter Mobile Number" onChange={(e)=>setSendermobilenumber(e.target.value)} />
                                                    </div>
                                                    <div className="col-12 col-md-6 mb-3">
                                                        <label className="form-label">Email ID:</label>
                                                        <input type="text" className="form-control" value={senderemail} placeholder="Enter email address" onChange={(e)=>setSenderemail(e.target.value)}/>
                                                    </div>
                                                    <div className="col-12 col-md-12 mb-3">
                                                        <label className="form-label">Complete Address <span className="text-danger">*</span>:</label>
                                                        <input type="text" className="form-control" value={senderAddress} placeholder="Enter full address" onChange={(e)=>setSenderAddress(e.target.value)} />
                                                    </div>
                                                    <div className="col-12 col-md-12 mb-3">
                                                        <label className="form-label">Pin/Postal/Zip code:</label>
                                                        <input type="text" className="form-control" value={senderPostalcode} placeholder="Enter pincode" onChange={(e)=>{setSenderPostalcode(e.target.value);handelsenderpostalcode(e.target.value)}}/>
                                                    </div>
                                                    <div className="col-12 col-md-6 mb-3">
                                                        <label className="form-label">Country <span className="text-danger">*</span>:</label>
                                                        <select className="form-select" onChange={handelsendercountry}>
                                                            <option>--Please Select--</option>
                                                            {countrylist.map((cl)=>{
                                                                return(
                                                                    <option value={cl.id}  key={cl.id} selected={senderdefaultCountryid === cl.id || sendercountryid === cl.id}>{cl.country}</option>
                                                                );
                                                            })}
                                                        </select>
                                                    </div>
                                                    <div className="col-12 col-md-6 mb-3">
                                                        <label className="form-label">City <span className="text-danger">*</span>:</label>
                                                        <Typeahead
                                                            filterBy={filterBy}
                                                            id="toggle-example"
                                                            options={citylist}
                                                            placeholder="Choose a city..."
                                                            onChange={handelsenderautoselectcity}
                                                            selected={pincodeSenderCity}
                                                        />
                                                    </div>
                                                    <div className="col-12 col-md-12">
                                                        <div className="form-check form-check-inline form-check">
                                                        <input className="form-check-input " type="checkbox" id="inlineCheckbox1" checked={sender_save_yes === 'yes'} onChange={handleSenderSaveAddress} />
                                                        <label className="form-check-label" for="inlineCheckbox1"><small className="text-muted">Save this address</small></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md">
                                        <h5>Add Receiver Details</h5>
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="d-flex justify-content-between mb-4">
                                                    <small className="text-muted">Where is the order being sent from?</small>
                                                    <div className="text-end">
                                                        <small><a data-bs-toggle="collapse" data-bs-target="#recautofill" className="text-primary">Use Auto Fill<i className="bx bx-chevron-down"></i></a></small>
                                                    </div>
                                                </div>

                                                <div className="row ">
                                                    <div className="col-12 col-md-12 mb-3 collapse show" id="recautofill">
                                                        <label className="form-label">Auto Fill details using:</label>
                                                        <div className="input-group select_account">
                                                            <select className="form-select" style={{"width": "20px !important"}} onChange={(e)=>setReceiverautofilltype(e.target.value)}>
                                                                {/* <option value=''>--Please Select--</option> */}
                                                                <option value='phone'>Mobile</option>
                                                                <option value='uniqueid'>Account Number</option>
                                                                <option value='address'>Address UID</option>
                                                            </select>
                                                            <input type="text" className="form-control" placeholder="Enter details to fetch data" value={receiverautofilldata} onChange={(e)=>handlereceiversearchdata(e.target.value)} />
                                                            
                                                        </div>
                                                        {showReceiverSelectBox &&
                                                            <select className="form-select customtypehead" size="5" onChange={(e)=>handleReceiverdata(e.target.value)}>
                                                                {receiverautofilllist.map((al,i)=>{
                                                                return(
                                                                <option value={al.value} className="searchtypehead">{al.label} {al.value}</option>
                                                                    )
                                                                })}
                                                            </select>
                                                            }
                                                    </div>
                                                    <div className="col-12 col-md-12 mb-3">
                                                        <label className="form-label">Company Name:</label>
                                                        <input type="text" className="form-control" value={receivercompanyname} placeholder="Enter Company Name" onChange={(e)=>setReceivercompanyname(e.target.value)} />
                                                    </div>
                                                    <div className="col-12 col-md-12 mb-3">
                                                        <label className="form-label">Full Customer Name <span className="text-danger">*</span> :</label>
                                                        <input type="text" className="form-control" value={receivercustomername} placeholder="Enter Customer Name" onChange={(e)=>setReceivercustomername(e.target.value)} />
                                                    </div>
                                                    <div className="col-12 col-md-6 mb-3">
                                                        <label className="form-label">Mobile Number <span className="text-danger">*</span>:</label>
                                                        <input type="number" className="form-control" value={receivermobilenumber} placeholder="Enter Mobile Number" onChange={(e)=>setReceivermobilenumber(e.target.value)} />
                                                    </div>
                                                    <div className="col-12 col-md-6 mb-3">
                                                        <label className="form-label">Email ID:</label>
                                                        <input type="text" className="form-control" value={receiveremail} placeholder="Enter email address" onChange={(e)=>setReceiveremail(e.target.value)}/>
                                                    </div>
                                                    <div className="col-12 col-md-12 mb-3">
                                                        <label className="form-label">Complete Address <span className="text-danger">*</span>:</label>
                                                        <input type="text" className="form-control" value={receiverAddress} placeholder="Enter full address" onChange={(e)=>setReceiverAddress(e.target.value)} />
                                                    </div>
                                                    <div className="col-12 col-md-12 mb-3">
                                                        <label className="form-label">Pin/Postal/Zip code:</label>
                                                        <input type="text" className="form-control" value={receiverPostalcode} placeholder="Enter pincode" onChange={(e)=>{setReceiverPostalcode(e.target.value);handelreceiverpostalcode(e.target.value)}}/>
                                                    </div>
                                                    <div className="col-12 col-md-6 mb-3">
                                                        <label className="form-label">Country <span className="text-danger">*</span>:</label>
                                                        <select className="form-select" onChange={handelreceivercountry}>
                                                            <option>--Please Select--</option>
                                                            {countrylist.map((cl,i)=>{
                                                                return(
                                                                    <option value={cl.id} selected={receiverdefaultCountryid == cl.id || receivercountryid == cl.id} key={i}>{cl.country}</option>
                                                                );
                                                            })}
                                                        </select>
                                                    </div>
                                                    <div className="col-12 col-md-6 mb-3">
                                                        <label className="form-label">City <span className="text-danger">*</span>:</label>
                                                        <Typeahead
                                                            filterBy={filterBy}
                                                            id="toggle-example"
                                                            options={citylist}
                                                            placeholder="Choose a city..."
                                                            onChange={handelReceiverautoselectcity}
                                                            selected={pincodeReceiverCity}
                                                        />
                                                    </div>
                                                    <div className="col-12 col-md-12">
                                                        <div className="form-check form-check-inline form-check">
                                                        <input className="form-check-input " type="checkbox" id="inlineCheckbox2" checked={receiver_save_yes === 'yes'} onChange={handleReceiverSaveAddress} />
                                                        <label className="form-check-label" for="inlineCheckbox2"><small className="text-muted">Save this address</small></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            
                            <section className="mb-4">
                                <h5>Order Details</h5>
                                <div className="card">
                                    <div className="card-body">
                                            <div className="row">
                                                <div className="col-12 col-md-12 mb-3">
                                                    <label className="form-label">Description <span className="text-danger">*</span>:</label>
                                                    <input type="text" className="form-control" name="Description" placeholder="Enter order description" value={description} onChange={(e)=>setDescription(e.target.value)} />
                                                </div>
                                            </div>
                                            {orderbags.map((val, i) => (
                                            <div className="row" key={i}>
                                                <div className="col-12 col-md-5 mb-3">
                                                    <label className="form-label">Your reference ID / order ID <span className="text-danger">*</span>:</label>
                                                    <input type="text" className="form-control" name="orderid" placeholder="Enter your reference ID / order ID" value={val.orderid} onChange={(e)=>handleorderchange(e,i)} />
                                                </div>
                                                <div className="col-12 col-md-5 mb-3">
                                                    <label className="form-label">No. of boxes <span className="text-danger">*</span>:</label>
                                                    <input type="number" className="form-control" name="no_boxes" placeholder="Enter no. of boxes" value={val.no_boxes} onChange={(e)=>handleorderchange(e,i)} />
                                                </div>
                                                <div className="col-12 col-md-2">
                                                    <div className="mt-4">
                                                        {i ===0 ?
                                                        <button className="btn btn-primary" onClick={orderaddInput}><i className="bx bx-plus"></i></button>
                                                        :
                                                        <button className="btn btn-primary" onClick={()=>handleorderDelete(i)}><svg xmlns="http://www.w3.org/2000/svg" width="1rem" height="1rem" viewBox="0 0 24 24"><path fill="currentColor" d="M5 11v2h14v-2z"/></svg></button>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            ))}
                                </div>
                                </div>
                            </section>
                                            
                            <section className="mb-4">
                                <h5>Invoice Details</h5>
                                <div className="card">
                                    <div className="card-body">
                                    <h6>Payment Details</h6>
                                    <small>Select mode of payment that your buyer has chosen for the order</small>
                                    <div className="row mt-3">
                                            <div className="col-12 col-md-2">
                                                <div className="form-check form-check-inline">
                                                    <input className="form-check-input" type="radio" id="inlineRadiod20" checked={paymenttype == 'Prepaid'} onChange={()=>setPaymenttype('Prepaid')} />
                                                    <label className="form-check-label" for="inlineRadiod20">Prepaid </label>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-3">
                                                <div className="form-check form-check-inline">
                                                    <input className="form-check-input" type="radio" id="inlineRadiod21" checked={paymenttype == 'COD'} onChange={()=>setPaymenttype('COD')} />
                                                    <label className="form-check-label" for="inlineRadiod21">Cash On Delivery </label>
                                                </div>
                                            </div>
                                            {paymenttype =='COD' &&
                                            <div className="col-12 col-md-4">
                                                {/* <input type="text" className="form-control" placeholder="Enter COD Amount" onChange={(e)=>handlecodamount(Number(e.target.value))} /> */}
                                                <input 
                                                    type="text" 
                                                    className="form-control"
                                                    value={codprice} 
                                                    onChange={(e) => {
                                                    const value = Number(e.target.value);
                                                    const totalAmount = packages.reduce((sum, product) => sum + (parseFloat(product.ProductPrice) * parseInt(product.ProductQTY)), 0);
                                                    setCodprice(value > totalAmount ? 0 : value);
                                                }} 
                                                />
                                            </div>
                                            }
                                        </div>
                                        <hr/>
                                            {invoices.map((val, i) => (
                                            <div className="row" key={i}>
                                                <div className="col-12 col-md-4 mb-3">
                                                    <label className="form-label">E-Way Bill Number<span className="text-danger"></span>:</label>
                                                    <input
                                                        type="text"
                                                        inputMode="numeric"
                                                        pattern="[0-9]*"
                                                        maxLength="12"
                                                        className="form-control"
                                                        name="EWayBillNumber"
                                                        placeholder="Enter your reference ID / order ID"
                                                        value={val.orderid}
                                                        onChange={(e) => {
                                                            const onlyNums = e.target.value.replace(/\D/g, '');
                                                            handleInvoiceschange({ ...e, target: { ...e.target, value: onlyNums } }, i);
                                                        }}
                                                        onPaste={(e) => {
                                                            const pasted = e.clipboardData.getData('text');
                                                            if (/\D/.test(pasted)) e.preventDefault(); // Block if pasted text contains non-numbers
                                                        }}
                                                        onDrop={(e) => {
                                                            e.preventDefault(); // Block drag-drop
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                            'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab',
                                                            ];
                                                            if (
                                                            !/^\d$/.test(e.key) &&
                                                            !allowedKeys.includes(e.key)
                                                            ) {
                                                            e.preventDefault();
                                                            }
                                                        }}
                                                        />

                                                </div>
                                                <div className="col-12 col-md-3 mb-3">
                                                    <label className="form-label">Invoice Number <span className="text-danger">*</span>:</label>
                                                    <input type="text" className="form-control" name="InvoiceNumber" placeholder="Enter invoice number" value={val.no_boxes} onChange={(e)=>handleInvoiceschange(e,i)} />
                                                </div>
                                                <div className="col-12 col-md-3 mb-3">
                                                    <label className="form-label">Amount <span className="text-danger">*</span>:</label>
                                                    <input type="number" className="form-control" name="Amount" placeholder="Enter no. of boxes" value={val.no_boxes} onChange={(e)=>handleInvoiceschange(e,i)} />
                                                </div>
                                                <div className="col-12 col-md-2">
                                                    <div className="mt-4">
                                                        {i ===0 ?
                                                        <button className="btn btn-primary" onClick={InvoicesaddInput}><i className="bx bx-plus"></i></button>
                                                        :
                                                        <button className="btn btn-primary" onClick={()=>handleInvoicesDelete(i)}><svg xmlns="http://www.w3.org/2000/svg" width="1rem" height="1rem" viewBox="0 0 24 24"><path fill="currentColor" d="M5 11v2h14v-2z"/></svg></button>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            ))}
                                        {/* <input type="checkbox" name="ewaybillon" checked={isChecked} onChange={handleChange}/> I will add E-Way Bill later/ E-Way Bill not required for this shipment */}
                                        <hr/>
                                        <h6>Insurance</h6>
                                        <small>Select the insurance mode for the shipment</small>
                                        <div className="row mt-3">
                                            <div className="col-12 col-md-2">
                                                <div className="form-check form-check-inline">
                                                    <input className="form-check-input" type="radio" id="or" value="option2" checked={insurance == 'No'} onChange={()=>setInsurance('No')} />
                                                    <label className="form-check-label" for="or">OR <a href="#" title="Owner Risk"><i className="bx bx-help-circle"></i></a></label>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-3">
                                                <div className="form-check form-check-inline">
                                                    <input className="form-check-input" type="radio" id="cr" checked={insurance == 'Yes'} onChange={()=>setInsurance('Yes')} />
                                                    <label className="form-check-label" for="cr">CR <a href="#" title="Carrier Risk"><i className="bx bx-help-circle"></i></a></label>
                                                </div>
                                            </div>
                                        </div>
                                </div>
                                </div>
                            </section>
                        </div>
                        <div className="col-12 col-md-4 sticky-bottom">
                            <section className="mb-4">
                                <h5>Product Details</h5>
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row mb-3">
                                            <div className="col-12 col-md-12">
                                                <button type="button" className="btn btn-outline-light btnboard" onClick={addPackage}>Add Another Box Size</button>
                                            </div>
                                            <div className="col-12 col-md-4"></div>
                                        </div>
                                        {packages.map((pkg, packageIndex) => (
                                            <>
                                            <div key={`package-${packageIndex}`} className="card bg-gray-100">
                                                <div className="card-body">
                                                    <h5>Package {packageIndex + 1}</h5>
                                                    <div className="row">
                                                    <div className="col-12 col-md-12 mb-3">
                                                        <label className="form-label">
                                                        Number of boxes
                                                        </label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="BoxNumber"
                                                            placeholder="0"
                                                            onChange={(e) => handlechangepackage(e, packageIndex)}
                                                        />
                                                    </div>
                                                    <div className="col-12 col-md-6 mb-3">
                                                            <label className="form-label">
                                                                Height (CM)
                                                            </label>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                name="Height"
                                                                placeholder="0"
                                                                onChange={(e) => handlechangepackage(e, packageIndex)}
                                                            />
                                                    </div>
                                                    <div className="col-12 col-md-6 mb-3">
                                                            <label className="form-label">
                                                                Width (CM)
                                                            </label>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                name="Width"
                                                                placeholder="0"
                                                                onChange={(e) => handlechangepackage(e, packageIndex)}
                                                            />
                                                    </div>
                                                        <div className="col-12 col-md-6 mb-3">
                                                                <label className="form-label">
                                                                    Length (CM)
                                                                </label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    name="Length"
                                                                    placeholder="0"
                                                                    onChange={(e) => handlechangepackage(e, packageIndex)}
                                                                />
                                                        </div>
                                                        <div className="col-12 col-md-6 mb-3">
                                                                <label className="form-label">
                                                                    Weight (KG)
                                                                </label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    name="Weight"
                                                                    placeholder="0"
                                                                    onChange={(e) => handlechangepackage(e, packageIndex)}
                                                                />
                                                                
                                                        </div>
                                                        {/* <div className="col-12 col-md-3 mb-3">
                                                            <span className="input-group-text">KG</span>
                                                        </div> */}
                                                        <div className="mt-4">
                                                        {packageIndex ===0 ?
                                                        ''
                                                        :
                                                        <button className="btn btn-primary" onClick={()=>handleDelete(packageIndex)}><svg xmlns="http://www.w3.org/2000/svg" width="1rem" height="1rem" viewBox="0 0 24 24"><path fill="currentColor" d="M5 11v2h14v-2z"/></svg></button>
                                                        }
                                                    </div>
                                                    </div>
                                                </div>
                                            </div>
                                           <br />
                                           </>
                                        ))}
                                    </div>
                                </div>
                            </section>
                            <section className="mb-4">
                                <h5>Upload Documents</h5>
                                <div className="card">
                                    <div className="card-body">
                                        <h6>Upload Documents</h6>
                                        <small>Max size 20MB</small>
                                        <div className="row mt-3">
                                            <div className="col-12 col-md bulk_import fileinput">
                                                {selectedFile ? (
                                                        <div style={styles.previewContainer}>
                                                        <div style={styles.iconContainer}>
                                                            <img
                                                            src="https://img.icons8.com/ios-filled/50/document.png"
                                                            alt="icon"
                                                            style={styles.icon}
                                                            />
                                                        </div>
                                                        <div style={styles.filename}>{selectedFile.name}</div>
                                                        <span style={styles.apicon} onClick={()=>setSelectedFile(null)}>X</span>
                                                        </div>
                                                    ):(
                                                    <div className="card fileupload">
                                                        <div className="card-body">
                                                            <label className="custom-file-upload">
                                                                <input type="file" onChange={(e)=>setSelectedFile(e.target.files[0])} accept=".png,.jpg,.jpeg,.pdf,.bmp" />
                                                                <i className="fa fa-cloud-upload"></i> Browse and Upload
                                                            </label>
                                                            <p>Upload Document (PNG, JPG, JPEG, PDF)</p>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                       <h6 className="mt-3">Secondary Document (Optional)</h6>
                                       <select name="" className="form-control" onChange={(e)=>handelSecondaryDocumnet(e.target.value)}>
                                        <option value="">Select Document Type</option>
                                        <option value="Ewaybill-Form">Ewaybill Form</option>
                                        <option value="Goods-Declaration">Goods Declaration</option>
                                        <option value="Delivery-Challan">Delivery Challan</option>
                                        <option value="PO-Copy">PO Copy</option>
                                        <option value="KYC">KYC</option>
                                        <option value="Regulatory-Form">Regulatory Form</option>
                                        <option value="Photo-ID">Photo ID</option>
                                        <option value="ASN">ASN</option>
                                        <option value="Einvoice-QR">Einvoice QR</option>
                                       </select>
                                        <div className="row mt-3">
                                            <div className="col-12 col-md bulk_import fileinput">
                                                {selectedSecondryFile ? (
                                                        <div style={styles.previewContainer}>
                                                        <div style={styles.iconContainer}>
                                                            <img
                                                            src="https://img.icons8.com/ios-filled/50/document.png"
                                                            alt="icon"
                                                            style={styles.icon}
                                                            />
                                                        </div>
                                                        <div style={styles.filename}>{selectedSecondryFile.name}</div>
                                                        <span style={styles.apicon} onClick={()=>setSelectedSecondryFile(null)}>X</span>
                                                        </div>
                                                    ):(
                                                    <div className="card fileupload">
                                                        <div className="card-body">
                                                            <label className="custom-file-upload">
                                                                <input type="file" onChange={(e)=>setSelectedSecondryFile(e.target.files[0])} accept=".png,.jpg,.jpeg,.pdf,.bmp" />
                                                                <i className="fa fa-cloud-upload"></i> Browse and Upload
                                                            </label>
                                                            <p>Upload Document (PNG, JPG, JPEG, PDF)</p>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            {servicelist != undefined && servicelist.length > 0 ?
                                ''
                            :
                                <div className="text-center">
                                    <button type="button" className="btn btn-primary btn-lg btn-block center" onClick={()=>handelservice()}>Show service</button>
                                </div>    
                            }
                        </div>
                    </div >
            </section >
            {/* Modal */}
            <Modal size="lg" show={showModal} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Service Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12 col-md">
                            <div className="row">
                                <div className={`col-12 ${selectedservicelist !== undefined && selectedservicelist.totalprice ? 'col-md-6': 'col-md-12'} mb-3`}>
                                    <section className="sele_service mb-4">
                                        <h5>Choose shipping service</h5>
                                        {servicelist != undefined && servicelist.length > 0 ?
                                        <>
                                        {servicelist.map((ser,i)=>{
                                            const hasTotalPrice = ser.totalprice && ser.totalprice !== null && ser.totalprice !== '0.00';
                                            return(
                                            hasTotalPrice && (
                                            <div className="list-group mb-3" key={i}>
                                                <button type="button" className={`list-group-item list-group-item-action ${selectedservicelist.unique_id == ser.unique_id ?'active':''}`} onClick={()=>handelactiveservice(i)}>
                                                    <div className="text-center">
                                                        <h2><small>{defaultCurrency}</small>{ser.totalprice}</h2>
                                                        <h6>{ser.services_name}</h6>
                                                        <h6>Estimated Delivery {ser.days} Days</h6>
                                                    </div>
                                                </button>
                                            </div>
                                            )
                                            );
                                            })}
                                            </>
                                        :
                                            <div className="list-group">
                                                <a href="#" className="list-group-item list-group-item-action bg-danger">
                                                    <div className="text-center text-white">
                                                        <h2 className=""><i className="bx bx-error"></i></h2>
                                                        <h6>No service available for the selected locations</h6>
                                                    </div>
                                                </a>
                                            </div>
                                        }
                                    </section>
                                </div>
                                <div className="col-12 col-md-6 mb-3">
                                    {selectedservicelist !=undefined && selectedservicelist.totalprice &&
                                    <section className="cost_brake mb-4">
                                        <h6 className="">Shipping Cost Breakup</h6>
                                        <div className="card">
                                            <div className="card-body">
                                                <table className="table">
                                                    <tbody>
                                                        {selectedservicelist !=undefined && selectedservicelist.service_charge > 0 &&
                                                        <tr>
                                                            <td>Freight Cost</td>
                                                            <td>{selectedservicelist !=undefined && selectedservicelist.service_charge}</td>
                                                        </tr>
                                                        }
                                                        {selectedservicelist !=undefined && selectedservicelist.totalFuelsurchage > 0 &&
                                                        <tr>
                                                            <td>Fuel Surcharge</td>
                                                            <td>{selectedservicelist !=undefined && selectedservicelist.totalFuelsurchage}</td>
                                                        </tr>
                                                        }
                                                        {selectedservicelist !=undefined && selectedservicelist.custom_clearence > 0 &&
                                                        <tr>
                                                            <td>Custom Clearance</td>
                                                            <td>{selectedservicelist !=undefined && selectedservicelist.custom_clearence}</td>
                                                        </tr>
                                                        }
                                                        {selectedservicelist !=undefined && selectedservicelist.codCharge > 0 &&
                                                        <tr>
                                                            <td>COD</td>
                                                            <td>{selectedservicelist !=undefined && selectedservicelist.codCharge}</td>
                                                        </tr>
                                                        }
                                                        {selectedservicelist !=undefined && selectedservicelist.odaCharge > 0 &&
                                                        <tr>
                                                            <td>ODA</td>
                                                            <td>{selectedservicelist !=undefined && selectedservicelist.odaCharge}</td>
                                                        </tr>
                                                        }
                                                        {selectedservicelist !=undefined && selectedservicelist.insurance_chagre > 0 &&
                                                        <tr>
                                                            <td>Insurance</td>
                                                            <td>{selectedservicelist !=undefined && selectedservicelist.insurance_chagre}</td>
                                                        </tr>
                                                        }
                                                        {selectedservicelist !=undefined && selectedservicelist.esscharge > 0 &&
                                                        <tr>
                                                            <td>ESS Surcharge</td>
                                                            <td>{selectedservicelist !=undefined && selectedservicelist.esscharge}</td>
                                                        </tr>
                                                        }
                                                        {selectedservicelist !=undefined && selectedservicelist.elevated_risk_charge > 0 &&
                                                        <tr>
                                                            <td>Elevated Risk</td>
                                                            <td>{selectedservicelist !=undefined && selectedservicelist.elevated_risk_charge}</td>
                                                        </tr>
                                                        }
                                                        {selectedservicelist !=undefined && selectedservicelist.restricted_destination > 0 &&
                                                        <tr>
                                                            <td>Restricted Destination</td>
                                                            <td>{selectedservicelist !=undefined && selectedservicelist.restricted_destination}</td>
                                                        </tr>
                                                        }
                                                        {selectedservicelist !=undefined && selectedservicelist.remoterareadelivery > 0 &&
                                                        <tr>
                                                            <td>Remote Area Delivery</td>
                                                            <td>{selectedservicelist !=undefined && selectedservicelist.remoterareadelivery}</td>
                                                        </tr>
                                                        }
                                                        {selectedservicelist !=undefined && selectedservicelist.service_tax_val > 0 &&
                                                        <tr>
                                                            <td>GST - {selectedservicelist !=undefined && selectedservicelist.service_tax}%</td>
                                                            <td>{selectedservicelist !=undefined && selectedservicelist.service_tax_val}</td>
                                                        </tr>
                                                        }
                                                        {selectedservicelist !=undefined && selectedservicelist.vat_tax_val > 0 &&
                                                        <tr>
                                                            <td>VAT - {selectedservicelist !=undefined && selectedservicelist.vat_tax}%</td>
                                                            <td>{selectedservicelist !=undefined && selectedservicelist.vat_tax_val}</td>
                                                        </tr>
                                                        }
                                                        <tr>
                                                            <td>Total</td>
                                                            <td>{selectedservicelist !=undefined && selectedservicelist.totalprice}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <br/>
                                        {/* <h5>Shipment Details</h5>
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-12 col-md-12 mb-3">
                                                        <label className="form-label"><small>Shipment Product Type</small>:</label>
                                                        <p>{product_Type}</p>
                                                    </div>
                                                    <div className="col-12 col-md-12 mb-3">
                                                        <label className="form-label"><small>Order Mode</small>:</label>
                                                        <p>{paymenttype}</p>
                                                    </div>
                                                    <div className="col-12 col-md-12 mb-3">
                                                        <label className="form-label"><small>Insurance Type</small>:</label>
                                                        <p>{insurance}</p>
                                                    </div>
                                                    <div className="col-12 col-md-12 mb-3">
                                                        <label className="form-label"><small>Total Weight <a href="" data-bs-toggle="popover" data-bs-trigger="hover" data-bs-content="Total physical weight of shipment"><i className="bx bx-help-circle"></i></a></small>:</label>
                                                        <p>{totalValues.Weight} KG</p>
                                                    </div>
                                                    <div className="col-12 col-md-12 mb-3">
                                                        <label className="form-label"><small>Volumetric Weight <a href="" data-bs-toggle="popover" data-bs-trigger="hover" data-bs-content="Volumetric Weight is calculated by HxWxL/5000"><i className="bx bx-help-circle"></i></a> </small>:</label>
                                                        <p>{servicelist != undefined && servicelist.length > 0 && servicelist[0].volumetricweight}KG</p>
                                                    </div>
                                            <div className="col-12 col-md-12 mb-3">
                                                <div className="card border-0 bg-gray-100">
                                                    <div className="card-body">
                                                        <div className="d-flex justify-content-between">
                                                            <h6>Total Chargeable Weight</h6>
                                                            <h6>{servicelist != undefined && servicelist.length > 0 && servicelist[0].volumetricweight} KG</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                            </div>
                                        </div> */}
                                    </section>
                                    }
                                </div>
                                {selectedservicelist !='' && (
                                            setloader == false ? (
                                            <div>
                                                <div className="d-grid">
                                                    <button type="button" className="btn btn-primary btn-lg btn-block " onClick={()=>createshipment()}>Create Shipment </button>
                                                </div>
                                            </div>
                                            ):(
                                            <div>
                                                <div className="d-grid">
                                                    <a href="" className="btn btn-primary btn-lg btn-block disabled"> <span className="spinner"></span></a>
                                                </div>
                                            </div>
                                            )
                                    ) }
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={handleClose}>Close</Button>
                </Modal.Footer>
            </Modal>
        <Footer />
            </main >
        </>
    )
}
const styles = {
  previewContainer: {
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #eee',
    borderRadius: '8px',
    padding: '8px 12px',
    maxWidth: '300px',
    marginTop: '12px',
    backgroundColor: '#fafafa'
  },
  iconContainer: {
    marginRight: '10px'
  },
  icon: {
    width: '24px',
    height: '24px'
  },
  filename: {
    fontSize: '14px',
    color: '#333'
  },
  apicon: {
    border: '1px solid',
    borderRadius: '15px',
    width: '20px',
    margin: '0px auto',
    paddingRight:'0.5rem',
    paddingLeft: '0.3rem',
    cursor: 'pointer'
}
};
export default Createshipmentb2b;